import { render, staticRenderFns } from "./AISystemItem.vue?vue&type=template&id=f39609b2&scoped=true&"
import script from "./AISystemItem.vue?vue&type=script&lang=ts&"
export * from "./AISystemItem.vue?vue&type=script&lang=ts&"
import style0 from "./AISystemItem.vue?vue&type=style&index=0&id=f39609b2&scoped=true&lang=css&"
import style1 from "./AISystemItem.vue?vue&type=style&index=1&id=f39609b2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f39609b2",
  null
  
)

export default component.exports